import React from 'react';
import { Navigate } from 'react-router-dom';
const PrivateRoute = ({ children }) => {
  
  const isAuthenticated = localStorage.getItem('userId');

 
    if(!isAuthenticated){
        return <Navigate to="/" replace />;
       
    }
       return children;
       
     
};

export default PrivateRoute;